import React, { useId, useState } from "react"
import { Repeater, types } from "react-bricks/frontend"
import { ButtonBrickProps } from "../../../../react-bricks/button/Button"
import ImageEditor, { AspectRatio } from "../../../../react-bricks/Image"
import { Color, TypographyColor } from "../../../../react-bricks/components/typography"
import Typography, { TypographyElement } from "../../../../react-bricks/Typography"
import { ButtonStyle } from "../../../../react-bricks/components/button"

interface TeaserProps {
    headline: TypographyElement[]
}

const Teaser: types.Brick<TeaserProps> = () => {
    const [isOpen, setIsOpen] = useState(0)

    const id = useId()

    return (
        <div className="rounded-base bg-darkblumine p-10 text-center text-white sm:rounded-lg sm:p-16 lg:p-24 xl:px-[110px]">
            <div className="mx-auto lg:max-w-[850px] xl:max-w-[1008px]">
                <Typography allowList={["sup", "link"]} propName="headline" block="heading-teaser" />
            </div>
            <div className="mt-5 grid gap-5 text-left sm:mt-7 sm:gap-10 md:mt-10 lg:mt-20 lg:grid-cols-2 lg:gap-24">
                <div className="lg:order-2">
                    <ImageEditor
                        className="sm:hidden lg:block"
                        aspectRatio={AspectRatio["4/5"]}
                        propName="imagePortrait"
                    />
                    <ImageEditor
                        className="hidden sm:block lg:hidden"
                        aspectRatio={AspectRatio["16/9"]}
                        propName="imageLandscape"
                    />
                </div>
                <Color color={TypographyColor.White}>
                    <Repeater
                        propName="accordion"
                        itemProps={{ setIsOpen, isOpen, id }}
                        renderWrapper={children => <ul>{children}</ul>}
                    />
                </Color>
            </div>
            <div className="lg:oder-1 order-2 mt-3 lg:mt-16">
                <Repeater
                    propName="button"
                    itemProps={
                        {
                            style: ButtonStyle.White,
                        } as ButtonBrickProps
                    }
                />
            </div>
        </div>
    )
}

Teaser.schema = {
    name: "Teaser",
    label: "Teaser",
    hideFromAddMenu: true,
    repeaterItems: [
        {
            name: "accordion",
            items: [
                {
                    type: "TeaserAccordion",
                    label: "Accordion",
                    min: 1,
                },
            ],
        },
        {
            name: "button",
            items: [
                {
                    type: "Button",
                    label: "Button",
                    min: 1,
                    max: 1,
                },
            ],
        },
    ],
    getDefaultProps: (): TeaserProps => ({
        headline: [
            {
                type: "h2",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet",
                    },
                ],
            },
        ],
    }),
}

export default Teaser
